import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import {
  getToken,
  getRefreshToken,
  removeToken,
  removeRefreshToken,
} from "@/utils/auth";
import router, { resetRouter } from "@/router";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
});

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["Authorization"] = `Bearer ${getToken()}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async function (error) {
    const { currentRoute } = router;
    const originalRequest = error.config;
    console.log("service error: ", error);
    // 401 - время жизни токена закончилось, нужно обновить
    const baseApi = process.env.VUE_APP_BASE_API_AUTH;
    if (
      getRefreshToken() &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      error.config?.url !== baseApi + "/auth/refresh/"
    ) {
      originalRequest._retry = true;

      try {
        const resp = await store.dispatch("user/refresh");

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + resp.access_token;

        return service(originalRequest);
      } catch (error) {
        console.log(error);
        removeToken(); // must remove  token  first
        removeRefreshToken();
        resetRouter();
        if (currentRoute.name !== `login`) {
          router.push({
            name: `login`,
            query: { redirect: currentRoute.path },
          });
        }
      }
    }
    if (error && !error.response) {
      Message({
        message: error,
        type: "error",
        duration: 5e3,
      });
      return Promise.reject(error);
    }

    const {
      response: {
        status,
        data,
        data: { message = `` },
      },
    } = error;

    if (status === 422) {
      Message({
        message: `Ошибка валидации, проверьте данные.`,
        type: "warning",
        duration: 5e3,
      });
      return Promise.reject(data);
    }

    if (status === 403) {
      Message({
        message: `Доступ запрещен.`,
        type: "error",
        duration: 5e3,
      });
      return Promise.reject(data);
    }

    // не показываем сообщение об ошибки для /documents/type/
    if (error.config?.url !== "/documents/type/") {
      Message({
        message: message ? `${message} (${status})` : error.message,
        type: "error",
        duration: 5e3,
      });
    }
    return Promise.reject(error);
  }
);

export default service;
